import React from 'react';
import { useFormikContext } from 'formik';
import { Button, Col, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

export default function SubmitButton() {
  const { isSubmitting, setFieldValue, submitForm } = useFormikContext();
  const history = useHistory();

  return (
    <Row className="d-flex justify-content-end my-3">
      <Col md={2} xl={2} lg={2} xs={12} className="pb-2">
        <Button
          block
          variant="outline-info"
          onClick={() => {
            localStorage.removeItem('settlementForm');
            history.push('/settlement_simulator');
          }}
          disabled={isSubmitting}
        >
          Cancelar
        </Button>
      </Col>
      <Col md={2} xl={2} lg={2} xs={12}>
        <Button
          block
          variant="primary"
          onClick={e => {
            e.preventDefault();
            setFieldValue('calculateSummary', true);
            submitForm();
          }}
          type="submit"
          disabled={isSubmitting}
        >
          Calcular
        </Button>
      </Col>
      <Col md={2} xl={2} lg={2} xs={12}>
        <Button
          block
          variant="primary"
          onClick={() => {
            setFieldValue('calculateSummary', false);
            submitForm();
          }}
          type="submit"
          disabled={isSubmitting}
        >
          Guardar
        </Button>
      </Col>
    </Row>
  );
}
